import { DEFAULT_FIELD_ERROR } from './constants';
const isNotEmpty = (value) => Boolean(value?.trim());
export const validateAirline = async (value, options) => {
    const trimmedValue = value.trim();
    if (!isNotEmpty(trimmedValue)) {
        return { error: DEFAULT_FIELD_ERROR };
    }
    if (options?.isValueInList === false) {
        return { error: 'Выберите авиакомпанию из списка' };
    }
    return { error: null };
};
